import { get, post } from "../APIGateWay";

export function getCookie(key) {
    const cookies = document.cookie
        .split(';')
        .map(cookie => cookie.split('='))
        .reduce((accumulator, [key, value]) =>
            ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {})
    return cookies[key]
}
export async function getListAssignment(data = {}) {
    return await get(data, '/assignment/list')
}
export async function getAssignment(data = {}) {
    return await get(data, '/assignment/detail')
}
export async function getAssignment2(data = {}) {
    return await get(data, '/assignment/detail/v2')
}
export async function submitAssignment(data) {
    return await post(data, '/assignment/submit')
}
export async function submitAssignment2(data) {
    return await post(data, '/assignment/submit/v2')
}
export async function uploadAssignment(data) {
    return await post(data, '/assignment/uploadfile')
}
